<template>
  <div>
    <b-container class="p-3 m-0 mw-100">
      <b-row>
        <b-col cols="auto">
          <h4>AWTrack</h4>
        </b-col>

        <b-col cols="auto" class="ml-auto">
          <b-dropdown dropleft no-caret v-if="logged">
            <div slot="button-content" class="d-inline-flex p-1">
              <font-awesome-icon icon="bars"/>
            </div>

            <b-dropdown-item @click="showUserModal">
              <font-awesome-icon icon="user" class="c-green"/>
              {{$tc('message.user', 1)}}
            </b-dropdown-item>

            <b-dropdown-divider />

            <b-dropdown-item @click="$router.push('/logout')">
              <font-awesome-icon icon="sign-out-alt" class="c-red"/>
              {{$tc('message.logout', 1)}}
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>
    </b-container>

    <b-modal ref="userModal" id="userModal" :title="`${$tc('message.user', 1)}`">
      <b-container>
        <b-row>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="d-flex">
              <h6><b>{{$tc('message.name', 1)}}:</b></h6>
              <h6 class="ml-2">{{user.fullName}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="d-flex">
              <h6><b>{{$tc('message.username', 1)}}:</b></h6>
              <h6 class="ml-2">{{user.userName}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="d-flex">
              <h6><b>{{$tc('message.email', 1)}}:</b></h6>
              <h6 class="ml-2">{{user.email || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button id="nw-delete-close" class="m-1 b-c-green" @click="hideDeleteModal()"> Ok </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Header',
  data () {
    const session = Vue.getLocalStorage('session')
    return {
      user: session ? session.user : {},
      logged: session && session.token
    }
  },
  watch: {
    '$route' () {
      const session = Vue.getLocalStorage('session')
      this.logged = session && session.token
      this.user = session ? session.user : {}
    }
  },
  methods: {
    showUserModal () {
      if (this.$refs.userModal) this.$refs.userModal.show()
    },
    hideDeleteModal () {
      this.$refs.userModal.hide()
    }
  }
}
</script>
